/**
 * Coaching ScreenModule barrel — editable IR authority (F2–F4).
 * Generated: docs/ui-truth/registry.generated.json via collectCoachingRegistry.
 */
export { loginScreenModule } from "./login";
export { dashboardScreenModule } from "./dashboard";
export { companiesScreenModule } from "./companies";
export { company_detailScreenModule } from "./company-detail";
export { programsScreenModule } from "./programs";
export { program_detailScreenModule } from "./program-detail";
export { cohortsScreenModule } from "./cohorts";
export { my_cohortsScreenModule } from "./my-cohorts";
export { cohort_createScreenModule } from "./cohort-create";
export { cohort_workspaceScreenModule } from "./cohort-workspace";
export { participantsScreenModule } from "./participants";
export { participant_detailScreenModule } from "./participant-detail";
export { cohort_bulk_participantsScreenModule } from "./cohort-bulk-participants";
export { org_admin_homeScreenModule } from "./org-admin-home";
export { organizationsScreenModule } from "./organizations";
export { org_reportsScreenModule } from "./org-reports";
export { meetingsScreenModule } from "./meetings";
export { sessionsScreenModule } from "./sessions";
export { calendarScreenModule } from "./calendar";
export { cohort_session_seriesScreenModule } from "./cohort-session-series";
export { clear_seriesScreenModule } from "./clear-series";
export { session_detailScreenModule } from "./session-detail";
export { session_invitesScreenModule } from "./session-invites";
export { session_rescheduleScreenModule } from "./session-reschedule";
export { reportsScreenModule } from "./reports";
export { report_detailScreenModule } from "./report-detail";
export { session_reportScreenModule } from "./session-report";
export { transcript_detailScreenModule } from "./transcript-detail";
export { resourcesScreenModule } from "./resources";
export { resource_detailScreenModule } from "./resource-detail";
export { capstoneScreenModule } from "./capstone";
export { capstone_submissionsScreenModule } from "./capstone-submissions";
export { certificatesScreenModule } from "./certificates";
export { historyScreenModule } from "./history";
export { usersScreenModule } from "./users";
export { user_detailScreenModule } from "./user-detail";
export { user_editScreenModule } from "./user-edit";
export { permissionsScreenModule } from "./permissions";
export { exportsScreenModule } from "./exports";
export { settingsScreenModule } from "./settings";
export { profileScreenModule } from "./profile";
export { settings_thresholdsScreenModule } from "./settings-thresholds";
export { toolsScreenModule } from "./tools";

import type { DefinedScreen } from "@vjal/screen-kit";
import { loginScreenModule } from "./login";
import { dashboardScreenModule } from "./dashboard";
import { companiesScreenModule } from "./companies";
import { company_detailScreenModule } from "./company-detail";
import { programsScreenModule } from "./programs";
import { program_detailScreenModule } from "./program-detail";
import { cohortsScreenModule } from "./cohorts";
import { my_cohortsScreenModule } from "./my-cohorts";
import { cohort_createScreenModule } from "./cohort-create";
import { cohort_workspaceScreenModule } from "./cohort-workspace";
import { participantsScreenModule } from "./participants";
import { participant_detailScreenModule } from "./participant-detail";
import { cohort_bulk_participantsScreenModule } from "./cohort-bulk-participants";
import { org_admin_homeScreenModule } from "./org-admin-home";
import { organizationsScreenModule } from "./organizations";
import { org_reportsScreenModule } from "./org-reports";
import { meetingsScreenModule } from "./meetings";
import { sessionsScreenModule } from "./sessions";
import { calendarScreenModule } from "./calendar";
import { cohort_session_seriesScreenModule } from "./cohort-session-series";
import { clear_seriesScreenModule } from "./clear-series";
import { session_detailScreenModule } from "./session-detail";
import { session_invitesScreenModule } from "./session-invites";
import { session_rescheduleScreenModule } from "./session-reschedule";
import { reportsScreenModule } from "./reports";
import { report_detailScreenModule } from "./report-detail";
import { session_reportScreenModule } from "./session-report";
import { transcript_detailScreenModule } from "./transcript-detail";
import { resourcesScreenModule } from "./resources";
import { resource_detailScreenModule } from "./resource-detail";
import { capstoneScreenModule } from "./capstone";
import { capstone_submissionsScreenModule } from "./capstone-submissions";
import { certificatesScreenModule } from "./certificates";
import { historyScreenModule } from "./history";
import { usersScreenModule } from "./users";
import { user_detailScreenModule } from "./user-detail";
import { user_editScreenModule } from "./user-edit";
import { permissionsScreenModule } from "./permissions";
import { exportsScreenModule } from "./exports";
import { settingsScreenModule } from "./settings";
import { profileScreenModule } from "./profile";
import { settings_thresholdsScreenModule } from "./settings-thresholds";
import { toolsScreenModule } from "./tools";

export const coachingScreenModules: DefinedScreen[] = [
  loginScreenModule,
  dashboardScreenModule,
  companiesScreenModule,
  company_detailScreenModule,
  programsScreenModule,
  program_detailScreenModule,
  cohortsScreenModule,
  my_cohortsScreenModule,
  cohort_createScreenModule,
  cohort_workspaceScreenModule,
  participantsScreenModule,
  participant_detailScreenModule,
  cohort_bulk_participantsScreenModule,
  org_admin_homeScreenModule,
  organizationsScreenModule,
  org_reportsScreenModule,
  meetingsScreenModule,
  sessionsScreenModule,
  calendarScreenModule,
  cohort_session_seriesScreenModule,
  clear_seriesScreenModule,
  session_detailScreenModule,
  session_invitesScreenModule,
  session_rescheduleScreenModule,
  reportsScreenModule,
  report_detailScreenModule,
  session_reportScreenModule,
  transcript_detailScreenModule,
  resourcesScreenModule,
  resource_detailScreenModule,
  capstoneScreenModule,
  capstone_submissionsScreenModule,
  certificatesScreenModule,
  historyScreenModule,
  usersScreenModule,
  user_detailScreenModule,
  user_editScreenModule,
  permissionsScreenModule,
  exportsScreenModule,
  settingsScreenModule,
  profileScreenModule,
  settings_thresholdsScreenModule,
  toolsScreenModule,
];

export const coachingScreenModulesById: Record<string, DefinedScreen> = Object.fromEntries(
  coachingScreenModules.map((m) => [m.ir.screen_id, m]),
);
